<template>
  <Modal
    inner-class="overflow-y-scroll rounded"
    size="none"
    custom-class="max-w-4xl max-h-full w-full"
    @close="closeBackInStockModal"
  >
    <div v-if="!showSuccess" class="md:flex">
      <div class="flex-1 bg-lightGold-40 p-16">
        <Headline tag="p" size="xl">
          {{ $t('back_in_stock_subscription_form.title', { size }) }}
        </Headline>
        <BackInStockForm class="mt-8" />
      </div>
      <div class="flex items-center justify-center p-12 md:w-1/3">
        <div v-if="product" class="flex flex-col items-center justify-center">
          <ProductImage
            fit="contain"
            :image="getProductImage(product.images, '_5')"
            :alt="productName"
            sizes="sm:100vw md:50vw"
            :should-trim="false"
            is-centered
            class="h-52"
          />
          <div class="">
            <div class="text-center text-lg">{{ productName }}</div>
            <div
              v-if="variant"
              class="mt-6 flex w-full justify-between gap-4 text-base"
            >
              <span
                >{{ $t('filter.size') }}: <b>{{ size }}</b></span
              >

              <ProductPrice
                :price="variant.price"
                :applied-reductions="variant.price.appliedReductions"
                type="whisper"
                vertical-align
                size="md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="pointer-events-none flex flex-col items-center gap-4 px-8 py-32 text-center"
    >
      <SuccessIcon class="size-16" />
      <Headline tag="p" size="2xl" :is-uppercase="false">
        {{ $t('back_in_stock_subscription_form.confirmation.title') }}
      </Headline>
      <p>
        {{ $t('back_in_stock_subscription_form.confirmation.description') }}
      </p>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { attr } from '~/utils/product'
import useBackInStock from '~/composables/useBackInStock'
import SuccessIcon from '@/assets/icons/success.svg'

const { showBackInStock, product, variant, showSuccess } = useBackInStock()

const size = computed(() => {
  const label = attr(variant.value, 'sizeCategorySize')?.label
  return (label?.includes('|') ? label?.split('|')[1] : label) as string
})
const productName = computed(() => attr(product.value, 'name')?.label || '')

const closeBackInStockModal = () => {
  showBackInStock.value = false
}
</script>
